import { ApiException } from '@api/api';

export const enum LoadingState {
  INIT = 'INIT',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
}

export interface ErrorState {
  error: Error | string | ApiException;
}

export type RequestState = LoadingState | ErrorState;

export interface BaseState {
  requestState: RequestState;
}

export const getStateError = (requestState: RequestState): Error | string | ApiException | null => {
  if ((requestState as ErrorState)?.error !== undefined) {
    return (requestState as ErrorState).error;
  }
  return null;
};
